import { OPTIONS_PER_PAGE } from "../constants/optionsConfig";

const getCurrentproductCount = (pageDetails) => {
    const { current_page, total_count } = pageDetails;
    if(current_page * OPTIONS_PER_PAGE.PRODUCTS > total_count){ 
      return total_count
    } else {
      return current_page * OPTIONS_PER_PAGE.PRODUCTS
    }
  }
   export default getCurrentproductCount;

   export function extractProductValues(data) {
    return data?.map(item => item.product);
  }

  export const getFormattedDate = (date) => {
    if (!date) {
      return null;
    }
    // For plain YYYY-MM-DD strings, parse as local date to avoid timezone shifting.
    // `new Date("2026-04-03")` parses as UTC midnight, which becomes the previous
    // day in negative-UTC regions. Constructing with explicit Y/M/D keeps it stable.
    let tempDate;
    if (typeof date === "string" && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
      const [year, month, day] = date.split("-").map(Number);
      tempDate = new Date(year, month - 1, day);
    } else {
      tempDate = new Date(date);
    }
    const formattedDate = tempDate.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });

    return formattedDate;
}

export const isMatchingItem = (bagItems, selectedSize, selectedColor, id, selectedOptions = null, selectedVariantId = null) => {
  if(!bagItems?.length)
    return false;
  
  // Check if using new structure with variant_id
  if (selectedVariantId) {
    return bagItems?.some(item => {
      // Check both variant_id and variant fields (API might use either)
      const itemVariantId = item?.variant_id || item?.variant;
      return itemVariantId === selectedVariantId && item?.product_id === id;
    });
  }
  
  // Check if using new structure with options
  if (selectedOptions && Object.keys(selectedOptions)?.length > 0) {
    return bagItems?.some(item => {
      if (item?.product_id !== id) return false;
      
      // Check if item has variant_id/variant or options
      const itemVariantId = item?.variant_id || item?.variant;
      
      if (itemVariantId) {
        // If bag item has variant_id, we need to match it with selectedVariantId
        // But if we don't have selectedVariantId, fall back to options matching
        // For now, check options match
        if (item?.options && Object.keys(selectedOptions)?.length > 0) {
          return Object.keys(selectedOptions).every(
            key => item?.options?.[key] === selectedOptions[key]
          );
        }
      }
      
      // If no variant_id but has options, match by options
      if (item?.options && Object.keys(selectedOptions)?.length > 0) {
        return Object.keys(selectedOptions).every(
          key => item?.options?.[key] === selectedOptions[key]
        );
      }
      
      // Fallback to old structure
      return false;
    });
  }
  
  if (selectedColor || selectedSize) {
    return bagItems?.some(item => 
      item?.color === selectedColor && item?.product_id === id && selectedSize === item?.size
    );
  }
  
  return bagItems?.some(item => {
    if (item?.product_id !== id) return false;
    const itemVariantId = item?.variant_id || item?.variant;
    const hasNoVariant = !itemVariantId && !item?.color && !item?.size && (!item?.options || Object.keys(item?.options || {})?.length === 0);
    return hasNoVariant;
  });
}

export const getMatchingItemSizes = (bagItems, selectedColor, id, selectedOptions = null) => {
  if (!bagItems?.length) return [];

  // If using new structure with options
  if (selectedOptions && Object.keys(selectedOptions)?.length > 0) {
    // Filter items with matching product_id and options
    const matchingItems = bagItems.filter(item => {
      if (item?.product_id !== id) return false;
      
      // Check if options match (excluding one option type to get available values)
      if (item?.options) {
        return Object.keys(selectedOptions)?.some(key => 
          item?.options?.[key] === selectedOptions[key]
        );
      }
      
      return false;
    });
    
    // Extract unique option values (this is a simplified version)
    // You might want to make this more specific based on your needs
    return matchingItems.map(item => item?.size || item?.options?.Size || '');
  }

  // Old structure
  return bagItems
    .filter(item => item?.color === selectedColor && item?.product_id === id)
    .map(item => item?.size);
};

export const roundToTwoDecimalPlaces=(num)=> {
  return parseFloat(num?.toFixed(2));
}

export function toTwoDecimalPlaces(value) {
  return parseFloat(value)?.toFixed(2);
}


export const truncateAtSpace = (text, maxLength) => {
  if (!text) return '';
  if (text.length <= maxLength) return text;

  const truncated = text.substring(0, maxLength);
  const lastSpace = truncated.lastIndexOf(' ');
  return truncated.substring(0, lastSpace) + '...';
};